import actions from './actions.js';
import reducers from './reducers';
import localStorage from './localStorage.js';

const redux = {
  reducers,
  actions,
  localStorage,
};

export default redux;
